/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstCalendarUpdateBase
 */
export interface MstCalendarUpdateBase {
    /**
     * 
     * @type {boolean}
     * @memberof MstCalendarUpdateBase
     */
    deleteFlg?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendarUpdateBase
     */
    insertDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarUpdateBase
     */
    insertUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendarUpdateBase
     */
    updateDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarUpdateBase
     */
    updateUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendarUpdateBase
     */
    deleteDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarUpdateBase
     */
    deleteUser?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCalendarUpdateBase
     */
    companyId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarUpdateBase
     */
    orgCenterId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendarUpdateBase
     */
    calendarDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCalendarUpdateBase
     */
    enableShip?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCalendarUpdateBase
     */
    enableArrival?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCalendarUpdateBase
     */
    enableOrder?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MstCalendarUpdateBase
     */
    arrivalRatio?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarUpdateBase
     */
    remarks?: string | null;
}

/**
 * Check if a given object implements the MstCalendarUpdateBase interface.
 */
export function instanceOfMstCalendarUpdateBase(value: object): value is MstCalendarUpdateBase {
    return true;
}

export function MstCalendarUpdateBaseFromJSON(json: any): MstCalendarUpdateBase {
    return MstCalendarUpdateBaseFromJSONTyped(json, false);
}

export function MstCalendarUpdateBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCalendarUpdateBase {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteFlg': json['delete_flg'] == null ? undefined : json['delete_flg'],
        'insertDatetime': json['insert_datetime'] == null ? undefined : (new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'] == null ? undefined : json['insert_user'],
        'updateDatetime': json['update_datetime'] == null ? undefined : (new Date(json['update_datetime'])),
        'updateUser': json['update_user'] == null ? undefined : json['update_user'],
        'deleteDatetime': json['delete_datetime'] == null ? undefined : (new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'] == null ? undefined : json['delete_user'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'orgCenterId': json['org_center_id'] == null ? undefined : json['org_center_id'],
        'calendarDate': json['calendar_date'] == null ? undefined : (new Date(json['calendar_date'])),
        'enableShip': json['enable_ship'] == null ? undefined : json['enable_ship'],
        'enableArrival': json['enable_arrival'] == null ? undefined : json['enable_arrival'],
        'enableOrder': json['enable_order'] == null ? undefined : json['enable_order'],
        'arrivalRatio': json['arrival_ratio'] == null ? undefined : json['arrival_ratio'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function MstCalendarUpdateBaseToJSON(json: any): MstCalendarUpdateBase {
    return MstCalendarUpdateBaseToJSONTyped(json, false);
}

export function MstCalendarUpdateBaseToJSONTyped(value?: MstCalendarUpdateBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'company_id': value['companyId'],
        'org_center_id': value['orgCenterId'],
        'calendar_date': value['calendarDate'] == null ? value['calendarDate'] : value['calendarDate'].toISOString(),
        'enable_ship': value['enableShip'],
        'enable_arrival': value['enableArrival'],
        'enable_order': value['enableOrder'],
        'arrival_ratio': value['arrivalRatio'],
        'remarks': value['remarks'],
    };
}

